module.exports = __webpack_public_path__ + "static/media/snail.164d4ca.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/pages/snail/snail_5thLeading/index/snail.mp3
// module id = FLXf
// module chunks = 1 18 19